angular.module('gym.workouts').controller('BulkWorkoutEnrolCtrl', ["$scope", "$rootScope", "$state", "$stateParams", "$http", "ngTableParams", "$filter", "EmploymentService", "FeatureNamesService", "flash", "report", "workout", function($scope, $rootScope, $state, $stateParams, $http, ngTableParams, $filter, EmploymentService, FeatureNamesService, flash, report, workout) {
  var getSelected, getTotal, gym, toggleRecipients;
  $scope.permissions = EmploymentService.get().permissions;
  if (!$scope.permissions.bulk_enrol_contact_workouts) {
    $state.go('gym.dashboard');
  }
  $scope.gym = gym = $rootScope.gym;
  $scope.workout = workout;
  $scope.report = report;
  $scope.contacts = report.candidates.map(function(contact) {
    contact.selected = !contact.already_enrolled;
    return contact;
  });
  $scope.workout.show_in_member_portal = JSON.parse($stateParams.show_in_member_portal);
  $scope.workout.show_history_in_member_portal = JSON.parse($stateParams.show_history_in_member_portal);
  $scope.workout.manageable_by_member = JSON.parse($stateParams.manageable_by_member);
  $scope.memberPortalLabel = FeatureNamesService.memberPortal();
  $scope.allRecipientsSelected = true;
  getTotal = function() {
    var ref;
    return ((ref = $scope.contacts) != null ? ref.length : void 0) || 0;
  };
  $scope.orderBy = {
    name: 'asc'
  };
  $scope.tableParams = new ngTableParams({
    page: 1,
    count: 50
  }, {
    counts: [],
    total: getTotal(),
    getData: function($defer, params) {
      var orderKey, recipients, reverse;
      orderKey = _.keys($scope.orderBy)[0];
      reverse = $scope.orderBy[orderKey] === 'desc';
      recipients = $filter('orderBy')($scope.contacts, orderKey, reverse);
      params.total(getTotal());
      return $defer.resolve(recipients.slice((params.page() - 1) * params.count(), params.page() * params.count()));
    }
  });
  $scope.toggleContact = function(contact) {
    $scope.contacts = $scope.contacts.map(function(item) {
      if (item.id === contact.id) {
        item.selected = !item.selected;
      }
      return item;
    });
    return $scope.allRecipientsSelected = _.every($scope.contacts, function(recipient) {
      return recipient.selected;
    });
  };
  $scope.isContactSelected = function(contact) {
    var item;
    item = _.find($scope.contacts, function(i) {
      return contact.id === i.id;
    });
    return item.selected;
  };
  toggleRecipients = function(recipients, value) {
    return recipients.map(function(recipient) {
      recipient.selected = value;
      return recipient;
    });
  };
  $scope.toggleRecipients = function() {
    $scope.allRecipientsSelected = !$scope.allRecipientsSelected;
    return $scope.contacts = toggleRecipients($scope.contacts, $scope.allRecipientsSelected);
  };
  $scope.showPageRange = function() {
    var prevPagesCount;
    prevPagesCount = ($scope.tableParams.page() - 1) * $scope.tableParams.count();
    return `${prevPagesCount + 1} - ${prevPagesCount + $scope.tableParams.data.length}`;
  };
  $scope.toggleSorting = function(column) {
    var order, params;
    params = {};
    order = $scope.orderBy[column] === 'asc' ? 'desc' : 'asc';
    params[column] = order;
    $scope.orderBy = params;
    return $scope.tableParams.reload();
  };
  $scope.isSortedBy = function(column, order) {
    return $scope.orderBy[column] === order;
  };
  $scope.isReady = function() {
    return !$scope.isLoading && _.find($scope.contacts, function(contact) {
      return contact.selected;
    });
  };
  getSelected = function() {
    return $scope.contacts.filter(function(contact) {
      return contact.selected;
    });
  };
  return $scope.submit = function() {
    var params, url;
    $scope.isLoading = true;
    url = `/gyms/${gym.id}/workouts/bulk_enrols`;
    params = {
      workout_id: workout.id,
      contact_ids: getSelected().map(function(item) {
        return item.id;
      }),
      show_in_member_portal: $scope.workout.show_in_member_portal,
      show_history_in_member_portal: $scope.workout.show_history_in_member_portal,
      manageable_by_member: $scope.workout.manageable_by_member
    };
    return $http.post(url, params).then(function(response) {
      $scope.isLoading = false;
      flash.success = response.data.message;
      return $state.go('gym.workouts.list');
    }, function(response) {
      $scope.isLoading = false;
      return flash.error = response.data.message;
    });
  };
}]);
